function formatBedroom(beds: string | string[]) {
    switch (beds) {
        case '0':
            return 'a studio';
        case '1':
            return `${beds} bedroom`;
        default:
            return `${beds} bedrooms`;
    }
}

export function formatBedrooms(
    bedsMax: string | string[],
    bedsMin: string | string[]
) {
    const formattedBedsMax = formatBedroom(bedsMax);
    const formattedBedsMin = formatBedroom(bedsMin);

    if (bedsMax && bedsMin) {
        if (bedsMax === bedsMin) {
            return `Max ${formattedBedsMax}`;
        }

        return `Between ${
            formattedBedsMin.split(' ')[0]
        } and ${formattedBedsMax}`;
    }

    if (bedsMax) {
        return `Max ${formattedBedsMax}`;
    }

    if (bedsMin) {
        return `Min ${formattedBedsMin}`;
    }

    return '';
}
